import { Component, Input, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import { NgForm } from '@angular/forms';
import { AuthType, ConstAuthClientCredentials, UipathConnectionType } from '../common/models/enums';
import { BzgRadioChange } from 'bz-genome-angular/radio/radio-button/radio-button.component';
import { BzgModalService } from 'bz-genome-angular';
import { ConfirmModalComponent } from '../common-components/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { RpaBotsService } from 'app/rpa-bots/core/rpa-bots.service';

@Component({
  selector: 'uipath-configuration',
  templateUrl: 'uipath-configuration.component.html',
  styleUrls: ['uipath-configuration.component.scss']
})
export class UipathConfigurationComponent implements OnInit {
  private _originalConnection: RpaConnectorDetail;
  public chartsVisible: boolean;
  public retriesVisible: boolean;
  public URL_REGEXP = /^((((https?|ftps?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/;
  //public uipathConnectionType = UipathConnectionType;
  //public authType = AuthType;
  public constAuthClientCredentials = ConstAuthClientCredentials;
  public botDetailData: IRpaConnectionUiPath;
  change_onPremisoToCloudTitle: string;
  change_onPremisoToCloudMessage: string;
  public authUrlOnPremise: string = '';

  @Output() save = new EventEmitter<any>();
  @Output() testConnection = new EventEmitter<any>();
  @Input() botDetail: IRpaConnectionUiPath;
  @Input() public uiPathOriginalConnection: IRpaConnectionUiPath;
  @Input() public enableClientCredOnPremiseUipath: boolean;
  @ViewChild('botConfigForm', { static: false }) botConfigForm: NgForm;

  uipathConnectionType = {
    cloud: 'Cloud',
    onPremise: 'OnPremise'
  };

  authType = {
    apiAccess: 'ApiAccess',
    clientCredentials: 'ClientCredentials',
    classicAuth: 'ClassicAuth'
  };

  constructor(private _modalService: BzgModalService, private translate: TranslateService, private _rpaBotsService: RpaBotsService) {
  }

  ngOnInit(): void {
    this.translate.get('RPA_BOTS.CONFIRMATION').subscribe(translation => {
      this.change_onPremisoToCloudTitle = translation;
    });
    this.translate.get('RPA_BOTS.CHANGE_DATA_CONFIGURACION').subscribe(translation => {
      this.change_onPremisoToCloudMessage = translation;
    });

    if (!this.enableClientCredOnPremiseUipath) {
      this.botDetail = { ...this.botDetail, authUrl: ConstAuthClientCredentials.authUrl };
      if(this.botDetail.connectionType === UipathConnectionType.onPremise) {
        this.botDetail = { ...this.botDetail, authType: AuthType.classicAuth };
      }
    }

    if (this.botDetail) {
      this._originalConnection = _.cloneDeep(this.botDetail);
    }
  }

  onClearAll() {
    this.botDetail = {
      ...this.botDetail,
      server: '',
      password: '',
      tenancyName: '',
      userNameOrEmailAddress: '',
      authType: AuthType.clientCredentials,
      grantType: ConstAuthClientCredentials.grantType,
      authUrl: this.botDetail.connectionType === UipathConnectionType.cloud ? ConstAuthClientCredentials.authUrl : ''
    } as IRpaConnectionUiPath;
    this.botConfigForm.reset();

  }

  updateBotDetailProperty(property: string, value: any) {
    this.botDetail = { ...this.botDetail, [property]: value };
  }

  changeConnectionType(type: UipathConnectionType) {
    this.botDetail = { ...this.botDetail, connectionType: type };
    if (type == UipathConnectionType.cloud) {
      this.authUrlOnPremise = this.botDetail.authUrl;
      this.botDetail = { ...this.botDetail, authUrl: ConstAuthClientCredentials.authUrl };
      this.botDetail = { ...this.botDetail, authType: AuthType.clientCredentials };
    } else {
      this.botDetail = { ...this.botDetail, authUrl: this.authUrlOnPremise };
      this.botDetail = { ...this.botDetail, scope: ConstAuthClientCredentials.scope };
      if (!this.botDetail.authType) {
        this.botDetail = { ...this.botDetail, authType: AuthType.clientCredentials };
      }
    }

    if (!this.enableClientCredOnPremiseUipath && type == UipathConnectionType.onPremise) {
      this.botDetail = { ...this.botDetail, authType: AuthType.classicAuth };
    }
  }

  isValid(): boolean {
    return !this.botConfigForm || this.botConfigForm.valid;
  }

  onTestConnection() {
    this.testConnection.emit(this.botDetail);
  }

  onSave() {
    this.showConfirmDialog(() => { this.save.emit(this.botDetail); })
  }

  get hasChanges(): boolean {
    return !_.isEqual(this._originalConnection, this.botDetail);
  }

  showCharts() {
    this.chartsVisible = true;
    this.retriesVisible = false;
  }

  showRetries() {
    this.retriesVisible = true;
    this.chartsVisible = false;
  }

  closeCharts() {
    this.chartsVisible = false;
  }

  closeRetries() {
    this.retriesVisible = false;
  }

  selectConnectionType(connectionType: string) {
    (this.botDetail as IRpaConnectionUiPath).connectionType = connectionType;
  }

  public showConfirmDialog(callback) {
    const deleteModal = this._modalService.open(ConfirmModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: this.change_onPremisoToCloudTitle,
        message: this.change_onPremisoToCloudMessage,
        button: "OK"
      }
    });
    deleteModal.afterClosed().subscribe((result: string) => {
      if (result === 'ok') {
        callback();
      }
    })
  }
}
